import { render, staticRenderFns } from "./filter-wrapper.vue?vue&type=template&id=16813126"
import script from "./filter-wrapper.vue?vue&type=script&lang=js"
export * from "./filter-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16813126')) {
      api.createRecord('16813126', component.options)
    } else {
      api.reload('16813126', component.options)
    }
    module.hot.accept("./filter-wrapper.vue?vue&type=template&id=16813126", function () {
      api.rerender('16813126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/filter/filter-wrapper.vue"
export default component.exports